import { render } from "./GPTChat.vue?vue&type=template&id=70cb2318&ts=true"
import script from "./GPTChat.vue?vue&type=script&lang=ts"
export * from "./GPTChat.vue?vue&type=script&lang=ts"

import "./GPTChat.vue?vue&type=style&index=0&id=70cb2318&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__